module.exports = __webpack_public_path__ + "static/media/Web9M.7dea1817.webp";